import React from "react";
import { Descriptions } from "antd";
import PreviewDrawer from "../../../../Common/PreviewDrawer";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { dateTimeFormat } from "../../../../../contstant";
import { USER_GROUP_SIZE, UserGroup } from "..";

interface NotificationViewProps {
  open: boolean;
  onClose: () => void;
  data: {
    title: string;
    description: string;
    group: string;
    createdAt: string;
    notificationType: string;
    status: string;
  } | null;
}

export default function NotificationViewModal(props: NotificationViewProps) {
  const { open, onClose, data } = props;
  const { t } = useTranslation();

  if (!data) return null;

  // Read from the group, as in the list: a notification carries no recipient
  // count of its own yet. See DEVELOPER_TASKS.md.
  const recipients = USER_GROUP_SIZE[data.group as UserGroup];

  return (
    <PreviewDrawer
      title={t("pages.notificationCenter.viewNotification")}
      open={open}
      onClose={onClose}
    >
      <Descriptions bordered column={1} className="custom-descriptions">
        <Descriptions.Item
          label={t("pages.notificationCenter.notificationType")}
          className="capitalize-first-letter"
        >
          {data.notificationType}
        </Descriptions.Item>
        <Descriptions.Item label={t("pages.notificationCenter.title")}>
          {data.title}
        </Descriptions.Item>
        <Descriptions.Item label={t("pages.notificationCenter.message")}>
          {data.description}
        </Descriptions.Item>
        <Descriptions.Item label={t("pages.notificationCenter.userGroup")}>
          {data.group}
        </Descriptions.Item>
        <Descriptions.Item label={t("pages.notificationCenter.sent")}>
          {recipients === undefined
            ? "—"
            : t("pages.notificationCenter.recipientsCount", {
                count: recipients,
                recipients: recipients.toLocaleString(),
              })}
        </Descriptions.Item>
        <Descriptions.Item label={t("pages.notificationCenter.sentAt")}>
          {dayjs(data.createdAt).format(dateTimeFormat)}
        </Descriptions.Item>
      </Descriptions>
    </PreviewDrawer>
  );
}
